import { useComSideMenu } from "@/components/layout/SideMenu/sideMenu";
import { useTuoHuonekortit } from "@/methods/huonekorttiComposablses";
import { hankePage } from "@/views/hanke";
import { ElMessage } from "element-plus";
import { computed, ref, watch } from "vue";
import type { TilaProperties } from "@/api/models/tila-properties";
import { TuontiHuonekortti } from "@/api/models/tuonti-huonekortti";

const state = ref({
    vastuuyksikko: undefined as undefined | number,
    huonekortit: [] as  {id: number, nimi: string}[],
    active: 0 as number,
    visible: false as boolean,
    kopioiLiitteet: true as boolean,
    tilatPerHuonekortti: {} as Record<number, TilaProperties[]>
})

export function useComTuonti() {
    const { huonekortit, clear: clearHuonekortit } = useComSideMenu()
    const { hankeVastuuyksikot: vastuuyksikot  } = hankePage()
    const { error, loading, response, importHuonekortit } = useTuoHuonekortit()
    const vastuuyksikko = computed({
        get: () => state.value.vastuuyksikko,
        set: (val: number | undefined) => {
            state.value.vastuuyksikko = val
        }
    })
    const active = computed({
        get: () => state.value.active,
        set: (val: number) => {
            state.value.active = val
        }
    })
    const visible = computed({
        get: () => state.value.visible,
        set: (val: boolean) => {
            state.value.visible = val
        }
    })
    const kopioiLiitteet = computed({
        get: () => state.value.kopioiLiitteet,
        set: (val: boolean) => {
            state.value.kopioiLiitteet = val
        }
    })
    const tilatPerHuonekortti = computed(() => state.value.tilatPerHuonekortti)

    const setTilojenMaara = (huonekorttiId: number, maara: number) => {
        const current = state.value.tilatPerHuonekortti[huonekorttiId] ?? []
        if (maara > current.length) {
            const uudet = Array.from({ length: maara - current.length }, () => ({} as TilaProperties))
            state.value.tilatPerHuonekortti[huonekorttiId] = [...current, ...uudet]
        } else {
            state.value.tilatPerHuonekortti[huonekorttiId] = current.slice(0, maara)
        }
    }

    const setTilatunnus = (huonekorttiId: number, index: number, tilatunnus: string) => {
        const tilat = state.value.tilatPerHuonekortti[huonekorttiId]
        if (tilat?.[index] !== undefined) {
            tilat[index] = { ...tilat[index], tilatunnus }
        }
    }

    const hyvaksy = () => {
        if(vastuuyksikko.value && huonekortit.value.length) {
            const _huonekortit: TuontiHuonekortti[] = huonekortit.value.map((h) => ({
                id: h.id,
                tilat: state.value.tilatPerHuonekortti[h.id] ?? [{}]
            }))
            importHuonekortit(vastuuyksikko.value, _huonekortit, kopioiLiitteet.value)
        }
    }
    const peruuta = () => {
        active.value = 0
        vastuuyksikko.value = undefined
        kopioiLiitteet.value = true
        state.value.tilatPerHuonekortti = {}
        clearHuonekortit()

        visible.value = false
    }

    watch(error, (val) => {
        if(val) {
            ElMessage.error("Tuonti epäonnistui!")
        }
    })
    watch(response, (val) => {
        if(!loading.value && val) {
            ElMessage.success("Tuonti onnistui!")
            peruuta()
        }
    })
    watch(huonekortit, (val) => {
        state.value.huonekortit = val
    })
    watch(active, (val) => {
        if (val === 2) {
            huonekortit.value.forEach((h) => {
                if (!state.value.tilatPerHuonekortti[h.id]) {
                    state.value.tilatPerHuonekortti[h.id] = [{}]
                }
            })
        }
    })

    return {
        vastuuyksikot,
        vastuuyksikko,
        huonekortit,
        visible,
        active,
        kopioiLiitteet,
        tilatPerHuonekortti,
        clearHuonekortit,
        peruuta,
        hyvaksy,
        setTilojenMaara,
        setTilatunnus
    }

}